"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Debouncer = void 0;
class Debouncer {
    debounceTime;
    maxDebounceTime;
    lastExecutionAt;
    timeoutRef = null;
    callback;
    constructor(debounceTime, maxDebounceTime, callback) {
        this.debounceTime = debounceTime;
        this.maxDebounceTime = maxDebounceTime;
        this.lastExecutionAt = 0;
        this.callback = callback;
    }
    shouldDebounce() {
        if (!this.maxDebounceTime) {
            return true;
        }
        const timeSinceLastExecution = Date.now() - this.lastExecutionAt;
        return timeSinceLastExecution < this.maxDebounceTime;
    }
    debounce(...args) {
        const shouldDebounce = !this.timeoutRef || this.shouldDebounce();
        this.clear();
        if (!shouldDebounce) {
            this.fire(...args);
        }
        else {
            this.timeoutRef = setTimeout(() => {
                this.fire(...args);
            }, this.debounceTime);
        }
    }
    fire(...args) {
        this.clear();
        this.lastExecutionAt = Date.now();
        this.callback(...args);
    }
    flush(...args) {
        this.fire(...args);
    }
    clear() {
        if (this.timeoutRef) {
            clearTimeout(this.timeoutRef);
            this.timeoutRef = null;
        }
    }
}
exports.Debouncer = Debouncer;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiRGVib3VuY2VyLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vc3JjL0RlYm91bmNlci50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7QUFFQSxNQUFhLFNBQVM7SUFDWixZQUFZLENBQVM7SUFDckIsZUFBZSxDQUFVO0lBQ3pCLGVBQWUsQ0FBUztJQUN4QixVQUFVLEdBQTBCLElBQUksQ0FBQztJQUN6QyxRQUFRLENBQXdCO0lBRXhDLFlBQ0UsWUFBb0IsRUFDcEIsZUFBdUIsRUFDdkIsUUFBK0I7UUFFL0IsSUFBSSxDQUFDLFlBQVksR0FBRyxZQUFZLENBQUM7UUFDakMsSUFBSSxDQUFDLGVBQWUsR0FBRyxlQUFlLENBQUM7UUFDdkMsSUFBSSxDQUFDLGVBQWUsR0FBRyxDQUFDLENBQUM7UUFDekIsSUFBSSxDQUFDLFFBQVEsR0FBRyxRQUFRLENBQUM7SUFDM0IsQ0FBQztJQUVPLGNBQWM7UUFDcEIsSUFBSSxDQUFDLElBQUksQ0FBQyxlQUFlLEVBQUUsQ0FBQztZQUMxQixPQUFPLElBQUksQ0FBQztRQUNkLENBQUM7UUFFRCxNQUFNLHNCQUFzQixHQUFHLElBQUksQ0FBQyxHQUFHLEVBQUUsR0FBRyxJQUFJLENBQUMsZUFBZSxDQUFDO1FBQ2pFLE9BQU8sc0JBQXNCLEdBQUcsSUFBSSxDQUFDLGVBQWUsQ0FBQztJQUN2RCxDQUFDO0lBRU0sUUFBUSxDQUFDLEdBQUcsSUFBTztRQUN4QixNQUFNLGNBQWMsR0FBRyxDQUFDLElBQUksQ0FBQyxVQUFVLElBQUksSUFBSSxDQUFDLGNBQWMsRUFBRSxDQUFDO1FBRWpFLElBQUksQ0FBQyxLQUFLLEVBQUUsQ0FBQztRQUViLElBQUksQ0FBQyxjQUFjLEVBQUUsQ0FBQztZQUNwQixJQUFJLENBQUMsSUFBSSxDQUFDLEdBQUcsSUFBSSxDQUFDLENBQUM7UUFDckIsQ0FBQzthQUFNLENBQUM7WUFDTixJQUFJLENBQUMsVUFBVSxHQUFHLFVBQVUsQ0FBQyxHQUFHLEVBQUU7Z0JBQ2hDLElBQUksQ0FBQyxJQUFJLENBQUMsR0FBRyxJQUFJLENBQUMsQ0FBQztZQUNyQixDQUFDLEVBQUUsSUFBSSxDQUFDLFlBQVksQ0FBQyxDQUFDO1FBQ3hCLENBQUM7SUFDSCxDQUFDO0lBRU8sSUFBSSxDQUFDLEdBQUcsSUFBTztRQUNyQixJQUFJLENBQUMsS0FBSyxFQUFFLENBQUM7UUFDYixJQUFJLENBQUMsZUFBZSxHQUFHLElBQUksQ0FBQyxHQUFHLEVBQUUsQ0FBQztRQUNsQyxJQUFJLENBQUMsUUFBUSxDQUFDLEdBQUcsSUFBSSxDQUFDLENBQUM7SUFDekIsQ0FBQztJQUVNLEtBQUssQ0FBQyxHQUFHLElBQU87UUFDckIsSUFBSSxDQUFDLElBQUksQ0FBQyxHQUFHLElBQUksQ0FBQyxDQUFDO0lBQ3JCLENBQUM7SUFFRCxLQUFLO1FBQ0gsSUFBSSxJQUFJLENBQUMsVUFBVSxFQUFFLENBQUM7WUFDcEIsWUFBWSxDQUFDLElBQUksQ0FBQyxVQUFVLENBQUMsQ0FBQztZQUM5QixJQUFJLENBQUMsVUFBVSxHQUFHLElBQUksQ0FBQztRQUN6QixDQUFDO0lBQ0gsQ0FBQztDQUNGO0FBekRELDhCQXlEQyJ9